<template>
  <div v-if="paginationLinks.length > 3" class="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6">
    <div class="flex flex-1 justify-between sm:hidden">
      <Link
        v-if="prev"
        :href="prev"
        class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Previous
      </Link>
      <Link
        v-if="next"
        :href="next"
        class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
      >
        Next
      </Link>
    </div>
    <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">{{ paginationFrom }}</span>
          to
          <span class="font-medium">{{ paginationTo }}</span>
          of
          <span class="font-medium">{{ paginationTotal }}</span>
          results
        </p>
      </div>
      <div>
        <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
          <template v-for="(link, index) in paginationLinks" :key="index">
            <Link
              v-if="link.url"
              :href="link.url"
              :class="[
                'relative inline-flex items-center px-4 py-2 text-sm font-semibold',
                link.active
                  ? 'z-10 bg-blue-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600'
                  : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0',
                index === 0 ? 'rounded-l-md' : '',
                index === paginationLinks.length - 1 ? 'rounded-r-md' : ''
              ]"
              :preserve-scroll="preserveScroll"
              v-html="link.label"
            />
            <span
              v-else
              :class="[
                'relative inline-flex items-center px-4 py-2 text-sm font-semibold pointer-events-none opacity-50',
                'text-gray-400 ring-1 ring-inset ring-gray-300',
                index === 0 ? 'rounded-l-md' : '',
                index === paginationLinks.length - 1 ? 'rounded-r-md' : ''
              ]"
              v-html="link.label"
            />
          </template>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import { computed } from 'vue';

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  links: {
    type: Array,
    default: () => [],
  },
  from: {
    type: Number,
    default: 0,
  },
  to: {
    type: Number,
    default: 0,
  },
  total: {
    type: Number,
    default: 0,
  },
  preserveScroll: {
    type: Boolean,
    default: true,
  },
});

// Support both data object and individual props
const paginationLinks = computed(() => props.data?.links || props.links);
const paginationFrom = computed(() => props.data?.from || props.from);
const paginationTo = computed(() => props.data?.to || props.to);
const paginationTotal = computed(() => props.data?.total || props.total);

const prev = computed(() => {
  const prevLink = paginationLinks.value.find(link => link.label.includes('Previous'));
  return prevLink?.url || null;
});

const next = computed(() => {
  const nextLink = paginationLinks.value.find(link => link.label.includes('Next'));
  return nextLink?.url || null;
});
</script>
